const AuthenticationUtil = require('../../util/authentication_util.js');

/**
 * A service used to deal with user authentication.
 * @deprecated Replaced by the standalone Authentication Util
 * @ngInject
 */
function AuthenticationService() {
  return {
    ...AuthenticationUtil
  };
}

module.exports = AuthenticationService;
